import { notaDataSortKey } from '../helpers/notaData';

const numOrZero = v => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

/**
 * Ordem estável para listagem de notas (data DESC + desempates por colunas visíveis).
 * Não usa validate.
 */
export function compareNotasByColumns(a, b) {
  const dataA = notaDataSortKey(a.data);
  const dataB = notaDataSortKey(b.data);
  if (dataB !== dataA) return dataB - dataA;

  const tipoCmp = String(a.tipo || '').localeCompare(String(b.tipo || ''), 'pt-BR');
  if (tipoCmp !== 0) return tipoCmp;

  const placaCmp = String(a.veiculoPlaca || '').localeCompare(String(b.veiculoPlaca || ''), 'pt-BR');
  if (placaCmp !== 0) return placaCmp;

  const valorA = numOrZero(a.valor);
  const valorB = numOrZero(b.valor);
  if (valorB !== valorA) return valorB - valorA;

  const usuarioCmp = String(a.usuarioNome || '').localeCompare(String(b.usuarioNome || ''), 'pt-BR');
  if (usuarioCmp !== 0) return usuarioCmp;

  const pagCmp = String(a.tipoPagamento || '').localeCompare(String(b.tipoPagamento || ''), 'pt-BR');
  if (pagCmp !== 0) return pagCmp;

  const auxCmp = String(a.inspetorAuxiliarNome || '').localeCompare(String(b.inspetorAuxiliarNome || ''), 'pt-BR');
  if (auxCmp !== 0) return auxCmp;

  return String(a.id || '').localeCompare(String(b.id || ''));
}
